import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { DreService } from 'src/app/admihair/service/dre.service';
import { DreAgrupada } from 'src/app/admihair/api/dto/dre-agrupada';


interface Mes {
  codigo: number,
  descricao: string
}

@Component({
  selector: 'app-dre-listar',
  templateUrl: './dre-listar.component.html',
  styleUrls: ['./dre-listar.component.scss']
})
export class DreListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild("filter") filter!: ElementRef;
  loading: boolean = false;
  loadingRelatorio: boolean = false;
  listaDreAgrupada: DreAgrupada[] = [];
  filtroAno: Date = new Date();

  listaMeses: SelectItem[] = [
    { label: 'JANEIRO', value: 1 },
    { label: 'FEVEREIRO', value: 2 },
    { label: 'MARÇO', value: 3 },
    { label: 'ABRIL', value: 4 },
    { label: 'MAIO', value: 5 },
    { label: 'JUNHO', value: 6 },
    { label: 'JULHO', value: 7 },
    { label: 'AGOSTO', value: 8 },
    { label: 'SETEMBRO', value: 9 },
    { label: 'OUTUBRO', value: 10 },
    { label: 'NOVEMBRO', value: 11 },
    { label: 'DEZEMBRO', value: 12 },
  ]
  mesSelecionado?: number;

  listaBaseDre: string[] = [
    'RECEITAS',
    'CUSTOS',
    'DESPESAS'
  ];
  baseDreSelecionada?: string;


  valorTotal: number = 0;

  constructor(
    private dreService: DreService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_DRE');
    //this.listar();
  }


  listar() {
    if (this.mesSelecionado && this.baseDreSelecionada) {
      this.loading = true;
      this.dreService.listarDreDetalhada(
        this.filtroAno.getFullYear(),
        this.mesSelecionado,
        this.baseDreSelecionada).subscribe({
          next: (data: DreAgrupada[]) => {
            this.listaDreAgrupada = data;
            this.calcularValorTotal(data);
            this.loading = false;
          },
          error: (err: any) => {
            this.loading = false;
            this.exibirMensagemErro(err);
          }
        })

    }
  }

  calcularValorTotal(lista: DreAgrupada[]) {
    this.valorTotal = 0;
    this.listaDreAgrupada.forEach(i => {
      this.valorTotal = this.valorTotal + i.total;
    })
  }


  carregarRelatorio() {
    this.loadingRelatorio = true;
    const ano = this.filtroAno.getFullYear();
    this.dreService.gerarRelatorioDre(ano).subscribe({
      next: (response: Blob) => {
        const url = URL.createObjectURL(response);
        window.open(url, 'blank');
        this.loadingRelatorio = false;
      },
      error: (err) => {
        this.loadingRelatorio = false;
        console.log(err);
      }
    });
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, "contains");
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = "";
  }

  excluir(indicadorId: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que deseja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {

      },
    });
  }

}
